import { motion } from "framer-motion";

export function Bar({ value, max, color = "#22C55E", label, testid, height = "h-3" }) {
  const pct = Math.max(0, Math.min(100, (value / Math.max(1, max)) * 100));
  return (
    <div data-testid={testid}>
      {label && (
        <div className="flex justify-between text-[11px] font-mono-game text-slate-400 mb-1">
          <span>{label}</span><span data-testid={testid ? `${testid}-value` : undefined}>{value}/{max}</span>
        </div>
      )}
      <div className={`${height} w-full rounded-full bg-slate-900 border border-slate-700/70 overflow-hidden`}>
        <motion.div className="h-full rounded-full" style={{ background: color, boxShadow: `0 0 10px ${color}88` }}
          initial={false} animate={{ width: `${pct}%` }} transition={{ type: "spring", stiffness: 120, damping: 20 }} />
      </div>
    </div>
  );
}
